
export interface INotification {
    text: string;
}

export interface IGlobalNotificationState {
    errorNotification: INotification;
    successNotification: INotification;
}

export const initialGlobalNotificationState: IGlobalNotificationState = {
    errorNotification: null,
    successNotification: null
};
